// extracted by mini-css-extract-plugin
export default {"container":"AddPost_container__uE+1I","input":"AddPost_input__HnGfn","textarea":"AddPost_textarea__-Hc6V","error":"AddPost_error__ZEfp9"};